import {Injectable} from '@angular/core';
import {SelectedAdvancedFilter} from '@bmc-ux/adapt-angular';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class GlobalAdvancedTableFilterService {

  public filter<T>(rowsData: T[], selectedFilters: SelectedAdvancedFilter[]): T[] {
    const filterableRows: T[] = [];

    if (selectedFilters && selectedFilters.length < 1) {
      return rowsData;
    }

    rowsData.forEach((curRow: T): void => {
      let matchingNumber = 0;

      selectedFilters.forEach((curFilter: SelectedAdvancedFilter): void => {
        switch (curFilter.filterOptionId) {
          case 'publishingStatus':
          case 'productStatus':
          case 'productSubType':
          case 'productFillInTabsCount':
          case 'baseBusinessUnit':
          case 'baseProductLine':
          case 'baseProductFamily':
            curFilter.value.forEach((curValue): void => {
              if (curRow[curFilter.filterOptionId] === curValue) {
                matchingNumber += 1;
              }
            });
            break;
          case 'hasPublishedVersion':
            if (curRow[curFilter.filterOptionId] === curFilter.value) {
              matchingNumber += 1;
            }
            break;
          case 'availabityDate':
            const filterReleaseDataFrom: string = curFilter.value[0] ? moment(curFilter.value[0]).format('YYYY-MM-DD') : '1970-01-01';
            const filterReleaseDataTo: string = curFilter.value[1] ? moment(curFilter.value[1]).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
            const rowReleaseDate: string = moment(curRow[curFilter.filterOptionId]).isValid() ? moment(curRow[curFilter.filterOptionId]).format('YYYY-MM-DD') : '-';
            const isBetween: boolean = moment(rowReleaseDate).isBetween(filterReleaseDataFrom, filterReleaseDataTo, 'date', '[]');

            if (rowReleaseDate !== '-' && isBetween) {
              matchingNumber += 1;
            }
            break;
        }
      });

      if (matchingNumber === selectedFilters.length) {
        filterableRows.push(curRow);
      }
    });

    return filterableRows;
  }
}
